import { Theme } from "@mui/material";

export const useStyles = () => ({
  packagesWrapper: (theme: Theme) => ({
    backgroundColor: "rgba(0, 130, 103, 0.05)",
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    width: "auto",
    borderRadius: "8px",
    color: theme.palette.secondary.contrastText,
  }),
  dividerRoot: (theme: Theme) => ({
    backgroundColor: theme.palette.learningTemplatePackage.main,
    marginTop: theme.spacing(2),
    height: "2px",
    opacity: "0.6",
  }),
  classPeriodWrapper: (theme: Theme) => ({
    backgroundColor: "#fff",
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    width: "auto",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.customColor.darkGray}`,
  }),
  classPeriodText: (theme: Theme) => ({
    fontWeight: 600,
    fontSize: "16px",
    color: theme.palette.secondary.contrastText,
  }),
  packageWrapper: (theme: Theme) => ({
    backgroundColor: "rgba(0, 130, 103, 0.05)",
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    padding: theme.spacing(2),
    width: "auto",
    borderRadius: "8px",
  }),
  divider: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
});
